import { useQuery } from "@tanstack/react-query"
import { apiRequest } from "../../utility/axios"
import { DateTime } from "luxon"
import { PrimeSpeedRow } from "../../common/common.types"
import { useEffect, useState } from 'react'
import { apiFetch, apiFetchBody } from '../../utility/fetch'

const useAmazonPageSpeedViewsRollingData = (userData) => {

  const now = DateTime.local().toUTC().toFormat('yyyy-MM-dd')
  const last30days = DateTime.fromISO(now).minus({days: 30}).toFormat('yyyy-MM-dd')

  // const {isLoading: isLoadingRolling, isPending: isPendingRolling, error: rollingError, data: rollingdata, isFetching: isFetchingRolling, refetch: refetchRolling } = useQuery<PrimeSpeedRow[]>({
  //   queryKey: ["RollingRows", last30days, now],
  //   queryFn: async (): Promise<PrimeSpeedRow[]> => {      
  //     const response = await apiRequest("GET", `/api/amazonPageSpeedViews`, null, {params: {startDate: last30days, endDate: now}})
  //     return response  as PrimeSpeedRow[]
  //   },
  // })

  const [isLoadingRolling, setIsLoadingRolling] = useState(false)
  const [isPendingRolling, setIsPendingRolling] = useState(false)
  const [isFetchingRolling, setIsFetchingRolling] = useState(false)
  const [rollingError, setRollingError] = useState(undefined)
  const [rollingData, setRollingData] = useState(undefined)
  const [refetchRolling, setRefetchRolling] = useState(undefined)

  useEffect(() => {
    const load = async () => {
      setIsLoadingRolling(true)
      try {
        const body = await apiFetchBody({
          endpoint: 'amazonPageSpeedViews',
          method: 'GET',
          accessToken: userData.accessToken,
          params: [{key: 'startDate', value: last30days}, {key: 'endDate', value: now}]
        })
        setRollingData(body)
      }catch(error){
        setRollingError(error)
      } finally {
        setIsLoadingRolling(false)
      }
    }
    load()
  }, [last30days, now, refetchRolling, userData])

  return {
    isLoadingRolling,
    isPendingRolling,
    rollingError,
    rollingData,
    isFetchingRolling,
    refetchRolling
  }
}

export default useAmazonPageSpeedViewsRollingData